import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Navbar from '../../Navbar';
import { Modal } from 'react-bootstrap';
import { showToast } from '../../../services';
import { profileActions } from '../../../actions';
import { userActions } from '../../../actions';
import { useLoggedUser } from '../../../hooks/useLoggedUser';

import userImage from '../../../assets/img/user.svg';
import Close from '../../../assets/img/close.svg';

const initialState = {
    selectedAvatar: null,
    submitted: false,
    showModal: false,
    showPurchaseButton: false,
};

const MyProfile = () => {
    const dispatch = useDispatch();
    const [state, setState] = useState(initialState);
    const loggedUser = useLoggedUser();

    const { myprofile } = useSelector((state) => state.myprofile);
    const { avatars } = useSelector((state) => state.users);
    const profile = Array.isArray(myprofile) && myprofile.length > 0 ? myprofile[0] : null;
    const favoriteActivities = Array.isArray(profile?.FavoriteString) ? profile.FavoriteString : [];

    useEffect(() => {
        if (!loggedUser?.data?.StudentProfileID) return;
        dispatch(profileActions.fetchMyprofile(loggedUser.data.StudentProfileID));
    }, [dispatch, loggedUser?.data?.StudentProfileID]);

    useEffect(() => {
        if (!loggedUser?.data?.StudentProfileID) return;
        dispatch(userActions.fetchprofileavatars(loggedUser.data.StudentProfileID));
    }, [dispatch, loggedUser?.data?.StudentProfileID]);

    const showModal = () => {
        setState(prevState => ({ ...prevState, showModal: true }));
    };

    const hideModal = () => {
        setState(prevState => ({ ...prevState, showModal: false, selectedAvatar: null, showPurchaseButton: false }));
    };

    const handleAvatarClick = (avatarId, isPurchased, isPaid) => {
        if (isPaid && !isPurchased) {
            setState(prevState => ({ ...prevState, selectedAvatar: avatarId, showPurchaseButton: true }));
        } else {
            setState(prevState => ({ ...prevState, selectedAvatar: avatarId, showPurchaseButton: false }));
        }
    };

    const handleUpdateAvatar = () => {
        const { selectedAvatar } = state;
        if (!selectedAvatar) {
            showToast('Please select an avatar', 'error');
            return;
        }

        dispatch(profileActions.updateProfileAvatar({
            StudentProfileID: loggedUser.data.StudentProfileID,
            AvatarID: selectedAvatar
        })).then((response) => {
            showToast(response.responseMessage, 'success');
            dispatch(profileActions.fetchMyprofile(loggedUser.data.StudentProfileID));
            hideModal();
        }).catch((error) => {
            // console.error('Error: ', error);
            showToast(error, 'error');
        });

        setState(prevState => ({ ...prevState, selectedAvatar: null, submitted: true }));
    };

    const purchaseAvatar = (avatarId, coincount) => {
        dispatch(profileActions.purchaseProfileAvatar({
            StudentProfileID: loggedUser.data.StudentProfileID,
            ProfileAvatarID: avatarId,
            PaidCoinCount: coincount
        })).then((response) => {
            if (response?.responseMessage === "You dont have enough coins to purchase this Profile Avatar") {
                showToast(response.responseMessage, 'warn');
                return;
            }
            // showToast(response.responseMessage, 'success');
            dispatch(userActions.fetchprofileavatars(loggedUser.data.StudentProfileID));
            dispatch(profileActions.fetchMypoints(loggedUser.data.StudentProfileID));
            handleUpdateAvatar();
            setState(prevState => ({ ...prevState, showPurchaseButton: false }));
        }).catch((error) => {
            // console.error('Error: ', error);
            showToast(error, 'error');
        });
    };

    return (
        <React.Fragment>
            <div className="continer-fluid profile-page">
                <Navbar />

                <div className="content" id="content">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                        <h2 className="profile-h">My Profile</h2>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3 p-0-7">
                            <div>
                                <div className="d-flex align-items-center flex-column">
                                    <img
                                        className="w-100 avatar-img"
                                        src={profile?.AvatarMedia || userImage}
                                        alt="profile"
                                    />
                                    <button
                                        type="button"
                                        className="change-btn mt-2"
                                        onClick={() => showModal()}
                                    >
                                        Change
                                    </button>
                                </div>
                            </div>
                            <div className="profile-div d-flex justify-content-between w-100 mt-2">
                                <div className="d-flex justify-content-between flex-column w-30">
                                    <div className='mt-2'>
                                        <label className="r-font profile-label-text">UserName</label>
                                        <label className="b-font p-l-txt-db">{profile?.UserName}</label>
                                    </div>
                                    <div className='mt-2'>
                                        <label className="r-font profile-label-text">Gender</label>
                                        <label className="b-font p-l-txt-db">{profile?.Gender}</label>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between flex-column w-35">
                                    <div className='mt-2'>
                                        <label className="r-font profile-label-text">First Name</label>
                                        <label className="b-font p-l-txt-db">{profile?.FirstName}</label>
                                    </div>
                                    <div className='mt-2'>
                                        <label className="r-font profile-label-text">Age</label>
                                        <label className="b-font p-l-txt-db">{profile?.Age}</label>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between flex-column w-30">
                                    <div className='mt-2'>
                                        <label className="r-font profile-label-text">Last Name</label>
                                        <label className="b-font p-l-txt-db">{profile?.LastName}</label>
                                    </div>
                                    <div className='mt-2'>
                                        <label className="r-font profile-label-text">Password</label>
                                        <label className="b-font p-l-txt-db">{profile?.EmailAddress}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h2 className="fav-act ">My Favourite Activities</h2>
                        <div className="row w-75 mt-3 ml-5 actves-cont-p">
                            {favoriteActivities.length > 0 ? (
                                favoriteActivities.map((favorite, index) => (
                                    <div key={favorite.ActivityID ?? `fav-${index}`} className="col-md-3 col-lg-3 col-sm-3 mb-2">
                                        <label className="b-font activity-name-p">{favorite.ActivityName}</label>
                                    </div>
                                ))
                            ) : (
                                <p>No favourite activities listed.</p>
                            )}
                        </div>
                    </div>

                </div>
            </div>

            <Modal className='avatar-modal' animation={false} show={state.showModal} onHide={hideModal}>
                <div className="modal-xl">
                    <div className="modal-header">
                        <h4 className="up-avatar-title">Select Your Avatar</h4>
                        <button type="button" className="close-btn" onClick={hideModal}>
                            <span aria-hidden="true"><img src={Close} /></span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row avatar-p-row">
                            {avatars && avatars.length > 0 ? (
                                avatars.map((avatar, index) => {
                                    const isPurchased = avatar.is_Purchased === "Y";
                                    const isPaid = avatar.AvatarType === "paid";
                                    return (
                                        <div className="col-md-3 col-lg-3 col-sm-3 mb-3 text-center" key={avatar.ProfileAvatarID ?? avatar.MediaID ?? `avatar-${index}`}>
                                            <div className='avatar-div d-flex justify-content-center'>
                                                {avatar.Media_URL ? (
                                                    <img
                                                        className={`avatar-img ${state.selectedAvatar === avatar.MediaID ? 'selected-avatar' : ''}`}
                                                        src={avatar.Media_URL}
                                                        alt="Avatar"
                                                        onClick={() => handleAvatarClick(avatar.MediaID, isPurchased, isPaid)}
                                                    />
                                                ) : (
                                                    <div>Image not available</div>
                                                )}
                                            </div>
                                            {isPaid && !isPurchased ? (
                                                // <label className="mt-2 coins-text">{avatar.CoinCount} coins</label>
                                                <label className="avatar-text text-center fw-7">{avatar.CoinCount} coins</label>
                                            ) : (
                                                <label className="mt-2 free-text">&nbsp;</label>
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <p>Avatars not available</p>
                            )}
                        </div>
                    </div>

                    <div className="modal-footer u-a-modal-f">
                        {state.showPurchaseButton ? (
                            <button type="button" className="accept-btn mt-2" onClick={() => purchaseAvatar(state.selectedAvatar, avatars.find(a => a.MediaID === state.selectedAvatar)?.CoinCount)}>
                                Purchase
                            </button>
                        ) : (
                            <button type="button" className="accept-btn mt-2" disabled={!state.selectedAvatar} onClick={handleUpdateAvatar}>
                                Update
                            </button>
                        )}
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
};

export default MyProfile;
